import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

const METER_TYPES: Record<string, string> = {
  electricity: 'Цахилгаан',
  water_hot: 'Халуун ус',
  water_cold: 'Хүйтэн ус',
  heating: 'Дулаан',
};

export default function MetersPage() {
  const [meters, setMeters] = useState<any[]>([]);
  const [readings, setReadings] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState<'meters' | 'readings'>('meters');

  useEffect(() => {
    Promise.all([
      api.get('/me/meters').catch(() => []),
      api.get('/admin/readings/queue').catch(() => []),
    ]).then(([m, r]) => {
      setMeters(m || []);
      setReadings(r || []);
    }).finally(() => setLoading(false));
  }, []);

  const approveReading = async (id: string) => {
    await api.post(`/admin/readings/${id}/approve`);
    setReadings(readings.filter(r => r.id !== id));
  };

  if (loading) return <p style={{ padding: 20 }}>Уншиж байна...</p>;

  return (
    <div>
      <h2 style={{ fontFamily: "'Inter'", fontWeight: 700, color: '#1c2b22', marginBottom: 16 }}>Тоолуур</h2>
      <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
        <TabBtn active={tab === 'meters'} onClick={() => setTab('meters')}>
          Тоолуурууд ({meters.length})
        </TabBtn>
        <TabBtn active={tab === 'readings'} onClick={() => setTab('readings')}>
          Баталгаажуулах ({readings.length})
        </TabBtn>
      </div>

      {tab === 'meters' ? (
        <div style={card}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid #e8e5dc', textAlign: 'left' }}>
                <th style={th}>Тоолуурын №</th>
                <th style={th}>Төрөл</th>
                <th style={th}>Орон сууц</th>
                <th style={th}>Сүүлийн заалт</th>
              </tr>
            </thead>
            <tbody>
              {meters.map((m: any) => (
                <tr key={m.id} style={{ borderBottom: '1px solid #e8e5dc' }}>
                  <td style={td}><strong>{m.meter_number}</strong></td>
                  <td style={td}>{METER_TYPES[m.meter_type] || m.meter_type}</td>
                  <td style={td}>{m.unit_number || '-'}</td>
                  <td style={td}>{m.last_reading ?? '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div style={card}>
          {readings.length === 0 ? (
            <p style={{ color: '#64748b', textAlign: 'center', padding: 40 }}>Баталгаажуулах заалт байхгүй</p>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #e8e5dc', textAlign: 'left' }}>
                  <th style={th}>Тоолуур</th>
                  <th style={th}>Заалт</th>
                  <th style={th}>Огноо</th>
                  <th style={th}>Эх сурвалж</th>
                  <th style={th}>Үйлдэл</th>
                </tr>
              </thead>
              <tbody>
                {readings.map((r: any) => (
                  <tr key={r.id} style={{ borderBottom: '1px solid #e8e5dc' }}>
                    <td style={td}>{r.meter_number}</td>
                    <td style={td}><strong>{r.value}</strong></td>
                    <td style={td}>{new Date(r.reading_date).toLocaleDateString()}</td>
                    <td style={td}>{r.source}</td>
                    <td style={td}>
                      <button onClick={() => approveReading(r.id)} style={{
                        background: '#10b981', color: '#fff', border: 'none',
                        padding: '4px 12px', borderRadius: 4, cursor: 'pointer', fontSize: 13,
                      }}>Батлах</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}

function TabBtn({ active, onClick, children }: { active: boolean; onClick: () => void; children: React.ReactNode }) {
  return (
    <button onClick={onClick} style={{
      padding: '8px 16px', border: 'none', borderRadius: 6, cursor: 'pointer',
      background: active ? '#236844' : '#e8e5dc', color: active ? '#fff' : '#2a3b32',
      fontWeight: 600, fontSize: 14,
    }}>{children}</button>
  );
}

const card: React.CSSProperties = {
  background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
};
const th: React.CSSProperties = { padding: '10px 12px', fontSize: 13, color: '#5f6f66', fontWeight: 600 };
const td: React.CSSProperties = { padding: '10px 12px', fontSize: 14, color: '#1c2b22' };
